import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../../helpers/JsonMappedModel";
import Store from "../../domain/Store";
import Image from "../../image/Image";
import BlockCollection from "../../blocks/BlockCollection";
import StorePageI18nCollection from "@/assets/js/models/store/storePage/StorePageI18nCollection";
import StorePageI18n from "@/assets/js/models/store/storePage/StorePageI18n";
var _attributes = /*#__PURE__*/new WeakMap();
export default class StorePage extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [StorePage.id_attribute_name]: null,
      [StorePage.language_attribute_name]: null,
      [StorePage.domain_attribute_name]: Store,
      [StorePage.type_attribute_name]: null,
      [StorePage.blocks_attribute_name]: BlockCollection,
      [StorePage.store_page_i18ns_attribute_name]: StorePageI18nCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getLanguageAttributeName() {
    return StorePage.language_attribute_name;
  }
  static getDomainAttributeName() {
    return StorePage.domain_attribute_name;
  }
  static getTypeAttributeName() {
    return StorePage.type_attribute_name;
  }
  static getBlocksAttributeName() {
    return StorePage.blocks_attribute_name;
  }
  static getStorePageI18nsAttributeName() {
    return StorePage.store_page_i18ns_attribute_name;
  }
  getStore() {
    return this.getAttribute(StorePage.domain_attribute_name);
  }
  getDomainName() {
    let domain = this.getStore();
    return domain instanceof Store ? domain.getName() : null;
  }
  getDomainLogo() {
    let domain = this.getStore();
    return domain instanceof Store ? domain.getLogo() : null;
  }
  getDomainLogoUrl() {
    let logo = this.getDomainLogo();
    return logo instanceof Image ? logo.getUrl() : null;
  }
  getLanguage() {
    return this.getAttribute(StorePage.language_attribute_name);
  }
  getType() {
    return this.getAttribute(StorePage.type_attribute_name);
  }
  getUrl() {
    let domainName = this.getDomainName();
    let uri = null;
    switch (this.getType()) {
      case StorePage.FAQ_PAGE:
        uri = StorePage.FAQ_PAGE;
        break;
      case StorePage.CONTACT_PAGE:
        uri = StorePage.CONTACT_PAGE;
        break;
      case StorePage.PRODUCT_PAGE:
        uri = 'products';
        break;
      case StorePage.ABOUT_PAGE:
        uri = StorePage.ABOUT_PAGE;
        break;
      case StorePage.SHIPPING_AND_RETURN_PAGE:
        uri = 'shipping-return-policy';
        break;
      case StorePage.SERVICE_TERMS_PAGE:
        uri = 'service-terms';
        break;
      case StorePage.PRIVACY_POLICY_PAGE:
        uri = 'privacy-policy';
        break;
      case StorePage.REFUND_POLICY_PAGE:
        uri = 'refund-policy';
        break;
    }
    return [/^localhost/.test(domainName) ? 'http:/' : 'https:/', domainName, uri].join('/');
  }
  getStorePageI18ns() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(StorePage.getStorePageI18nsAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getStorePageI18nBlocks(language) {
    const storePageI18ns = this.getStorePageI18ns();
    const storePageI18n = storePageI18ns.find(storePageI18n => storePageI18n instanceof StorePageI18n && storePageI18n.getLanguage() === language);
    return storePageI18n instanceof StorePageI18n ? storePageI18n.getBlocks() : [];
  }
  isHome() {
    return this.getType() === StorePage.HOME_PAGE;
  }
}
_defineProperty(StorePage, "HOME_PAGE", 'home');
_defineProperty(StorePage, "FAQ_PAGE", 'faq');
_defineProperty(StorePage, "CONTACT_PAGE", 'contact');
_defineProperty(StorePage, "PRODUCT_PAGE", 'product');
_defineProperty(StorePage, "ABOUT_PAGE", 'about');
_defineProperty(StorePage, "SHIPPING_AND_RETURN_PAGE", 'shipping_and_return');
_defineProperty(StorePage, "SERVICE_TERMS_PAGE", 'service_terms');
_defineProperty(StorePage, "PRIVACY_POLICY_PAGE", 'privacy_policy');
_defineProperty(StorePage, "REFUND_POLICY_PAGE", 'refund_policy');
_defineProperty(StorePage, "ARABIC_LANG_SHORT", 'ar');
_defineProperty(StorePage, "ENGLISH_LANG_SHORT", 'en');
_defineProperty(StorePage, "FRENCH_LANG_SHORT", 'fr');
_defineProperty(StorePage, "ITALY_LANG_SHORT", 'it');
_defineProperty(StorePage, "SPANISH_LANG_SHORT", 'es');
_defineProperty(StorePage, "id_attribute_name", 'id');
_defineProperty(StorePage, "language_attribute_name", 'language');
_defineProperty(StorePage, "domain_attribute_name", 'domain');
_defineProperty(StorePage, "type_attribute_name", 'type');
_defineProperty(StorePage, "blocks_attribute_name", 'blocks');
_defineProperty(StorePage, "store_page_i18ns_attribute_name", 'store_page_i18ns');